import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { MdVisibility, MdLogout } from 'react-icons/md';

/**
 * Floating impersonation indicator. Pinned to the bottom-right corner so it
 * never disrupts the page layout (no sticky bar pushing content down). Always
 * visible while an impersonator session is active.
 */
export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useContext(AuthContext);
  const [stopping, setStopping] = useState(false);

  if (!isImpersonating || !user) return null;

  const handleStop = async () => {
    try {
      setStopping(true);
      await stopImpersonation();
      window.location.href = '/';
    } catch (err) {
      console.error('Stop impersonation failed:', err);
      setStopping(false);
    }
  };

  return (
    <div
      role="status"
      aria-label="Impersonating user"
      style={{
        position: 'fixed',
        right: '1.25rem',
        bottom: '1.25rem',
        zIndex: 1000,
        background: '#7c2d12',
        color: '#fff',
        borderRadius: '6px',
        padding: '0.5rem 0.5rem 0.5rem 0.875rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        fontSize: '0.8125rem',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
        maxWidth: 'min(420px, calc(100vw - 2.5rem))'
      }}
    >
      <MdVisibility size={18} style={{ flexShrink: 0 }} aria-hidden="true" />
      <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
        <span style={{ opacity: 0.85 }}>Viewing as </span>
        <strong>{user.name}</strong>
      </div>
      <button
        onClick={handleStop}
        disabled={stopping}
        title="Stop impersonating"
        style={{
          background: 'rgba(255,255,255,0.2)',
          color: '#fff',
          border: 'none',
          padding: '0.35rem 0.65rem',
          borderRadius: '4px',
          fontSize: '0.75rem',
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.25rem',
          cursor: stopping ? 'wait' : 'pointer',
          flexShrink: 0
        }}
      >
        <MdLogout size={14} aria-hidden="true" />
        {stopping ? 'Stopping…' : 'Stop'}
      </button>
    </div>
  );
}
